import { Entity, RELATION_OWNED_BY } from '@backstage/catalog-model';
import {
  EntityRefLink,
  getEntityRelations,
} from '@backstage/plugin-catalog-react';
import { makeStyles, Theme } from '@material-ui/core';
import { EmptyCell } from './EmptyCell';
import { ownerInitials } from './owner-initials';
import { TruncatedText } from './TruncatedText';

const useStyles = makeStyles((theme: Theme) => ({
  owner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  avatar: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 24,
    height: 24,
    borderRadius: '50%',
    fontSize: 11,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  // Stays clickable above the Name link's stretched ::after.
  link: {
    position: 'relative',
    zIndex: 1,
  },
}));

export function OwnerCell({ entity }: { entity: Entity }) {
  const classes = useStyles();
  const owners = getEntityRelations(entity, RELATION_OWNED_BY);
  if (owners.length === 0) {
    return <EmptyCell />;
  }
  return (
    <>
      {owners.map(owner => (
        <div
          key={`${owner.kind}:${owner.namespace}/${owner.name}`}
          className={classes.owner}
        >
          <span className={classes.avatar} aria-hidden>
            {ownerInitials(owner.name)}
          </span>
          <TruncatedText>
            <EntityRefLink
              entityRef={owner}
              defaultKind="group"
              hideIcon
              className={classes.link}
            />
          </TruncatedText>
        </div>
      ))}
    </>
  );
}
